import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import styles from './styles.module.scss';
import BetResult from './BetResult';
import Bets from './Bets';

export default function GameReportBetDetails() {
  const { bets, isPending } = useGameReportData();

  return (
    <div className={styles.container}>
      <BetResult bets={bets} isPending={isPending} />
      <Bets bets={bets ?? []} isPending={isPending} />
    </div>
  );
}
